<div class="main-container lg-view">
  <h4 *ngIf="procedureName" class="header">{{ procedureName }}</h4>
  <ng-container>
    <div class="form-details-modal">
      <app-loader
        [isInline]="true"
        [hasTransparency]="true"
        [loaderMessage]="'Loading step data...'"
        *ngIf="isStepResultLoading || isStepPhotosLoading"
      ></app-loader>
      <mat-tab-group mat-align-tabs="center">
        <mat-tab label="Form Details">
                      <!-- *ngIf="!!routePayload.stepResult" -->
          <form-viewer
            [formTemplate]="routePayload.stepResult"
            [submitFormCallback]="noOp.bind(self)"
            [isReadOnly]="true"
          ></form-viewer>
        </mat-tab>
        <mat-tab label="Photos">
          <step-photos
            #stepPhotosComponent
            [photos]="routePayload.stepPhotos"
            [isLoading]="isStepPhotosLoading"
            [hideLoaded]="'true'"
          ></step-photos>
        </mat-tab>
        <mat-tab label="Participant" *ngIf="isFromSummaryReview">
          <div class="confirmation-history" *ngIf="participantTabContent && participantTabContent.length > 0">
            <div
              class="history-entry"
              *ngFor="let history of participantTabContent"
            >
              <ng-container *ngIf="history.comment">
                <div class="history-top">
                  <ng-container *ngIf="history.isConfirmed">
                    <button
                      [ngClass]="{'option-success': history.isConfirmed}"
                      mat-icon-button>
                      <mat-icon>check</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container
                    *ngIf="history.isIssueLogged"
                    class="label"
                  >
                    <button mat-icon-button>
                      <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
                    </button>
                  </ng-container>
                  <span class="history-status">
                    <span  [ngClass]="{'logged-issue-comment': !history.isConfirmed}">
                      <i>{{ history?.comment }}</i>
                    </span>
                  </span>
                </div>
                <span class="history-date">
                  by {{ history.copilotName }} 
                  on
                  {{ moment(history.lastUpdatedOn).format("MM/DD/YYYY") }}
                </span>
              </ng-container>
              <ng-container *ngIf="history.isConfirmed && !history.comment">
                <div class="history-top">
                  <button
                    class="option-success" mat-icon-button>
                    <mat-icon>check</mat-icon>
                  </button>
                  <span class="history-status">
                    <span>
                      <i>Confirmed</i>
                    </span>
                  </span>
                </div>
                <span class="history-date">
                  by {{ history.copilotName }} 
                  on
                  <ng-container *ngIf="history.isOnSiteCopilot">
                    {{ moment(history.signatureDate).format("MM/DD/YYYY") }}
                  </ng-container>
                  <ng-container *ngIf="!history.isOnSiteCopilot">
                    {{ moment(history.lastUpdatedOn).format("MM/DD/YYYY") }}
                  </ng-container>
                </span>
              </ng-container>
              <ng-container *ngIf="!history.isConfirmed && !history.isIssueLogged">
                <div class="history-top">
                  <button mat-icon-button>
                    <mat-icon class="svg-icon" [svgIcon]="'hourglass'"></mat-icon>
                  </button>
                  <span class="history-status">
                    <span class="logged-issue-comment">
                      <i>Pending Review</i>
                    </span>
                  </span>
                </div>
                <span class="history-date pending">
                  ({{ history.copilotName }})
                </span>
              </ng-container>
            </div>
          </div>
          <div class="no-data-container" *ngIf="!participantTabContent || participantTabContent.length === 0">
            <h4 class="no-data-text">No data.</h4>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </ng-container>
</div>
